<template>
  <div class="instant-break-wrapper">
    <div class="form-group">
      <select id="break-time" class="form-select-field">
        <option
          v-for="time in timeOptions"
          :key="time"
          :value="`${time} min`"
        >
          {{ `${time} min` }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label for="break-message" class="form-label">{{ trans("live.common.instant_break.pinned_message") }}</label>
      <textarea id="break-message" class="form-textarea-field textarea"></textarea>
    </div>

    <div class="action-buttons">
      <button
        class="btn btn-blue">
        {{ trans("live.common.instant_break.start_break") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, inject, reactive } from "vue";
  import { trans } from "@/utils/trans";

  const emit = defineEmits(["closeForm", "changeTitle", "setModalHeightAuto"]);
  const emitter = inject("emitter");

  const timeOptions = Array.from({ length: 48 }, (_, i) => (i + 1) * 5);

</script>
